import React from "react";
import assetify from "@quintype/framework/assetify";
import { string, number, oneOfType, object, bool } from "prop-types";
import get from "lodash/get";
import { connect } from "react-redux";

import DefaultMobileLogo from "../icons/default-mobile-logo";
import KiaLogo from "../icons/kia-logo";
import BondhushavaLogo from "../icons/BondhuShavaLogo";
import protichintaIcon from "../../../../assets/images/protichinta-icon.png";
import trustLogo from "../../../../assets/images/trust-logo.png";
import BigganChintaLogo from "../icons/BigganChintaLogo";
import EnglishHeaderLogo from "../icons/EnglishHeaderLogo";
import { headerLevelLogo, getCurrentSite } from "../../utils/utils";
import NagorikLogo from "../icons/NagorikLogo";

import "./mobileLogo.m.css";

const MobileLogo = ({
  domainSlug,
  color = "#C6CCD5",
  publisherAttributes,
  pageType,
  currentPath,
  editLogo = false
}) => {
  const HeaderTag = `h${headerLevelLogo(pageType)}`;

  const renderLogo = () => {
    if (domainSlug === "kishoralo" || getCurrentSite(currentPath) === "kishoralo") {
      return <KiaLogo width={93} height={46} color={color} />;
    } else if (domainSlug === "bondhushava" || getCurrentSite(currentPath) === "bondhushava") {
      return <BondhushavaLogo width={132} height={36} />;
    } else if (domainSlug === "protichinta" || getCurrentSite(currentPath) === "protichinta") {
      return <img src={`${assetify(protichintaIcon)}`} alt="ad-slot-768-x90" styleName="protichinta-logo" />;
    } else if (domainSlug === "biggan-chinta" || getCurrentSite(currentPath) === "biggan-chinta") {
      return <BigganChintaLogo width={165} height={45} />;
    } else if (domainSlug === "bigganchinta" || getCurrentSite(currentPath) === "bigganchinta") {
      return <BigganChintaLogo width={165} height={45} />;
    } else if (domainSlug === "trust" || getCurrentSite(currentPath) === "trust") {
      return (
        <img
          src={`${assetify(trustLogo)}`}
          alt="trust-logo"
          className="mobile-trust-logo trust-logo"
          styleName="trust-logo"
        />
      );
    } else if (domainSlug === "nagorik-sangbad" || getCurrentSite(currentPath) === "nagorik") {
      return <NagorikLogo width="190" height="26" color={editLogo ? "#ffffff" : "#34b8b5"} />;
    } else if (publisherAttributes.lang === "en" || getCurrentSite(currentPath) === "en") {
      return <EnglishHeaderLogo width="112.05" />;
    } else {
      return <DefaultMobileLogo width={165} height={38} />;
    }
  };

  return <HeaderTag className="mobile-logo">{renderLogo()}</HeaderTag>;
};

const mapStateToProps = state => ({
  domainSlug: get(state, ["qt", "config", "domainSlug"], ""),
  publisherAttributes: get(state, ["qt", "config", "publisher-attributes"], {}),
  pageType: get(state, ["qt", "pageType"], ""),
  currentPath: get(state, ["currentPathReducer", "currentPath"], null)
});

MobileLogo.propTypes = {
  domainSlug: string,
  width: oneOfType([string, number]),
  height: oneOfType([string, number]),
  color: string,
  publisherAttributes: object,
  pageType: string,
  currentPath: string,
  editLogo: bool
};

export default connect(mapStateToProps, null)(MobileLogo);
